export enum ActionTypes {
  FETCH_LOCATIONS = "locations-module/fetch-locations",
  FETCH_LOCATIONS_FOR_CSV = "locations-module/fetch-locations-for-csv",
  CREATE_LOCATION = "locations-module/create-location",
  UPDATE_LOCATION = "locations-module/update-location",
  DELETE_LOCATION = "locations-module/remove-location",
}
